<span *ngIf="icons">
  <img [appCacheBuster]="icons" width="38" height="38" (click)="onClick($event)" />
</span>
